import React from 'react';
import { Modal } from '@vectord/components';

import { CreateLessonForm } from 'features/classCreation';

export default function CreateLessonModal({
  isOpen,
  title,
  lessonType,
  handleClose,
  academyTopicId,
}) {
  return (
    <Modal
      isOpen={isOpen}
      size="large"
      className="p-b-xs"
      title={title}
      unMountOnClose
      onClose={handleClose}
    >
      <CreateLessonForm
        lessonType={lessonType}
        label={title}
        onSuccess={handleClose}
        academyTopicId={academyTopicId}
      />
    </Modal>
  );
}
